var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftsUtility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 132,
    viewBox: "0 0 131 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7683 13.6558C12.7683 6.11392 18.8864 0 26.4334 0H117.209C124.756 0 130.874 6.11392 130.874 13.6558V104.369C130.874 111.911 124.756 118.025 117.209 118.025H26.4334C18.8864 118.025 12.7683 111.911 12.7683 104.369V13.6558Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.209 0.975416H26.4334C19.4255 0.975416 13.7444 6.65262 13.7444 13.6558V104.369C13.7444 111.373 19.4255 117.05 26.4334 117.05H117.209C124.217 117.05 129.898 111.373 129.898 104.369V13.6558C129.898 6.65263 124.217 0.975416 117.209 0.975416ZM26.4334 0C18.8864 0 12.7683 6.11392 12.7683 13.6558V104.369C12.7683 111.911 18.8864 118.025 26.4334 118.025H117.209C124.756 118.025 130.874 111.911 130.874 104.369V13.6558C130.874 6.11392 124.756 0 117.209 0H26.4334Z",
    fill: "#3EF8A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1521 20.1528C19.1521 12.5462 25.2604 6.37975 32.7953 6.37975H109.782C117.317 6.37975 123.425 12.5462 123.425 20.1528V97.8725C123.425 105.479 117.317 111.646 109.782 111.646H32.7953C25.2604 111.646 19.1521 105.479 19.1521 97.8725V20.1528Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.782 7.36354H32.7953C25.7986 7.36354 20.1266 13.0895 20.1266 20.1528V97.8725C20.1266 104.936 25.7986 110.662 32.7953 110.662H109.782C116.779 110.662 122.451 104.936 122.451 97.8725V20.1528C122.451 13.0895 116.779 7.36354 109.782 7.36354ZM32.7953 6.37975C25.2604 6.37975 19.1521 12.5462 19.1521 20.1528V97.8725C19.1521 105.479 25.2604 111.646 32.7953 111.646H109.782C117.317 111.646 123.425 105.479 123.425 97.8725V20.1528C123.425 12.5462 117.317 6.37975 109.782 6.37975H32.7953Z",
    fill: "#3EF8A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6489 130.382C60.6489 129.572 59.992 128.915 59.1816 128.915H15.1623C8.40923 128.915 2.93476 123.445 2.93476 116.696L2.93476 72.7068C2.93476 71.897 2.27782 71.2405 1.46745 71.2405C0.657074 71.2405 0.000137329 71.897 0.000137329 72.7068L0.000137329 116.696C0.000137329 125.064 6.78848 131.848 15.1623 131.848H59.1816C59.992 131.848 60.6489 131.192 60.6489 130.382Z",
    fill: "#3EF8A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftsUtility);
export default __webpack_public_path__ + "static/media/nfts-utility.fbbb2aab2bf8de185fd131a2c0419075.svg";
export { ForwardRef as ReactComponent };